import { requestNoLogin } from '@/services/index'
export const state = {
  isLoading: false,
  qrCodeSecret: {
    success: false,
    data: {},
  },
  sendQrCodeSecret: {
    success: false,
    isLoading: true,
  },
  secret: '',
}

export const mutations = {
  SET_IS_LOADING(state) {
    state.isLoading = true
  },
  GET_QR_CODE(state, newValue) {
    state.qrCodeSecret = newValue
    state.isLoading = false
  },
  SET_SECRET(state, newValue) {
    state.secret = newValue?.secret
  },
  SEND_QR_CODE_SECRET(state, newValue) {
    state.sendQrCodeSecret = newValue
  },
  RESET_SECRET(state) {
    state.secret = ''
  },
}

export const getters = {
  qrCode(state) {
    return state.qrCodeSecret.data
  },
  qrCodeSuccess(state) {
    return state.qrCodeSecret.success
  },
  sendQrCodeSuccess(state) {
    return state.sendQrCodeSecret.success
  },
  isLoadingSendQr(state) {
    return state.sendQrCodeSecret.isLoading
  },
  getIsLoadingQrCode(state) {
    return state.isLoading
  },
  getSecret(state) {
    return state.secret
  },
}

export const actions = {
  async getQrCode({ commit, state }, params) {
    commit('SET_IS_LOADING')
    try {
      const response = await requestNoLogin({
        endpoint: 'api/limit/check_limit',
        payload: params,
      })
      const { data } = response
      let secret = data.secret
      if (state?.secret) {
        secret = state?.secret
      }
      commit('GET_QR_CODE', { success: true, data: { ...data, secret } })
      commit('SET_SECRET', { secret })
      return response
    } catch (error) {
      commit('GET_QR_CODE', { success: false, error })
      commit('SET_SECRET', '')
      return error
    }
  },
  async sendQrCode({ commit }, params) {
    return requestNoLogin({
      endpoint: 'api/limit/renew_limit',
      payload: params,
    })
      .then(() => {
        const result = {}
        result.success = true
        result.isLoading = false
        commit('SEND_QR_CODE_SECRET', result)
      })
      .catch(() => {
        const result = {}
        result.success = true
        result.isLoading = false
        commit('SEND_QR_CODE_SECRET', result)
      })
  },
  resetSecret({ commit }) {
    commit('RESET_SECRET')
  },
}
